export enum Errors {
  StarkCurveInvalidMessageLength = 'invalid message length',
}
